import InterfaceSuket from "../apiInterface/InterfaceSuket";
import ErrorAlert from "@/utility/ErrorAlert";

class DataSuket {
  async getDataRiwayatSuket(reg) {
    // let dt: object = {}
    let dt: any;
    await InterfaceSuket.getRiwayatSuket(reg)
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response
        ErrorAlert.showSnackAlert(e, "Riwayat Surat Keterangan")
      });
    return dt;
  }
  async getDataSKJiwa(reg) {
    let dt: any;
    await InterfaceSuket.getSKJiwa(reg)
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response
        ErrorAlert.showSnackAlert(e, "SK Jiwa")
      });
    return dt;
  }

  async getDataSKJiwaById(id) {
    let dt: any;
    await InterfaceSuket.getSKJiwaById(id)
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response
        ErrorAlert.showSnackAlert(e, "SK Jiwa By ID")
      });
    return dt;
  }

  async saveDataSKJiwa(
    reg, rm, unit_id, keterangan, tujuan
  ) {
    let dt: object = {};
    await InterfaceSuket.saveSKJiwa(
      reg, rm, unit_id, keterangan, tujuan
    )
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response;
        ErrorAlert.showErrorAlert(e);
      });
    return dt;
  }

  async editDataSKJiwa(
    id, reg, rm, unit_id, keterangan, tujuan
  ) {
    let dt: object = {};
    await InterfaceSuket.editSKJiwa(
      id, reg, rm, unit_id, keterangan, tujuan
    )
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response;
        ErrorAlert.showErrorAlert(e);
      });
    return dt;
  }

  async getDataSKNapza(reg) {
    let dt: any;
    await InterfaceSuket.getSKNapza(reg)
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response
        ErrorAlert.showSnackAlert(e, "SK Napza")
      });
    return dt;
  }

  async getDataSKNapzaById(id) {
    let dt: any;
    await InterfaceSuket.getSKNapzaById(id)
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response
        ErrorAlert.showSnackAlert(e, "SK Napza By ID")
      });
    return dt;
  }

  async saveDataSKNapza(
    reg, rm, unit_id, keterangan, tujuan
  ) {
    let dt: object = {};
    await InterfaceSuket.saveSKNapza(
      reg, rm, unit_id, keterangan, tujuan
    )
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response;
        ErrorAlert.showErrorAlert(e);
      });
    return dt;
  }

  async editDataSKNapza(
    id, reg, rm, unit_id, keterangan, tujuan
  ) {
    let dt: object = {};
    await InterfaceSuket.editSKNapza(
      id, reg, rm, unit_id, keterangan, tujuan
    )
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response;
        ErrorAlert.showErrorAlert(e);
      });
    return dt;
  }

  async getDataSKSehat(reg) {
    let dt: any;
    await InterfaceSuket.getSKSehat(reg)
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response
        ErrorAlert.showSnackAlert(e, "SK Sehat")
      });
    return dt;
  }

  async getDataSKSehatById(id) {
    let dt: any;
    await InterfaceSuket.getSKSehatById(id)
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response
        ErrorAlert.showSnackAlert(e, "SK Sehat By ID")
      });
    return dt;
  }

  async saveDataSKSehat(
    reg, rm, unit_id, keterangan, tujuan, sis, dias, tb, bb, darah
  ) {
    let dt: object = {};
    await InterfaceSuket.saveSKSehat(
      reg, rm, unit_id, keterangan, tujuan, sis, dias, tb, bb, darah
    )
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response;
        ErrorAlert.showErrorAlert(e);
      });
    return dt;
  }

  async editDataSKSehat(
    id, reg, rm, unit_id, keterangan, tujuan, sis, dias, tb, bb, darah
  ) {
    let dt: object = {};
    await InterfaceSuket.editSKSehat(
      id, reg, rm, unit_id, keterangan, tujuan, sis, dias, tb, bb, darah
    )
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response;
        ErrorAlert.showErrorAlert(e);
      });
    return dt;
  }

  async getDataSKIstirahat(reg) {
    let dt: any;
    await InterfaceSuket.getSKIstirahat(reg)
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response
        ErrorAlert.showSnackAlert(e, "SK Istirahat")
      });
    return dt;
  }

  async getDataSKIstirahatById(id) {
    let dt: any;
    await InterfaceSuket.getSKIstirahatById(id)
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response
        ErrorAlert.showSnackAlert(e, "SK Istirahat By ID")
      });
    return dt;
  }

  async saveDataSKIstirahatt(
    reg, rm, unit_id, keterangan, awal, akhir
  ) {
    let dt: object = {};
    await InterfaceSuket.saveSKIstirahat(
      reg, rm, unit_id, keterangan, awal, akhir
    )
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response;
        ErrorAlert.showErrorAlert(e);
      });
    return dt;
  }

  async editDataSKIstirahat(
    id, reg, rm, unit_id, keterangan, awal, akhir
  ) {
    let dt: object = {};
    await InterfaceSuket.editSKIstirahat(
      id, reg, rm, unit_id, keterangan, awal, akhir
    )
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response;
        ErrorAlert.showErrorAlert(e);
      });
    return dt;
  }
}

export default new DataSuket();
